import React, { useState } from 'react';
import { Input, Button } from 'reactstrap';
import { X, Search, Grid3x3, List } from 'lucide-react';
import AgentCard from './AgentCard';
import { cn } from '../../../utils/utils';
import './styles.scss';

const AgentSelector = ({ 
  agents = [], 
  onSelectAgent, 
  onClose, 
  selectedAgent,
  themeColor = '#6366f1',
  isRTL = false
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [viewMode, setViewMode] = useState('grid');

  // Filter agents based on search
  const filteredAgents = agents.filter(agent => {
    const query = searchQuery.toLowerCase();
    return (
      agent.name?.toLowerCase().includes(query) ||
      agent.description?.toLowerCase().includes(query)
    );
  });

  return (
    <div className="agent-selector" style={{ direction: isRTL ? 'rtl' : 'ltr' }}>
      {/* Header */}
      <div className="agent-selector-header">
        <h4>Select Agent</h4>
        <Button 
          color="link" 
          onClick={onClose}
          style={{ padding: '4px' }}
        >
          <X size={20} />
        </Button>
      </div>

      {/* Search and View Toggle */}
      <div className="agent-selector-controls">
        <div className="search-wrapper">
          <Search className="search-icon" size={20} />
          <Input
            type="text"
            placeholder="Search agents..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
        </div>
        
        <div className="view-toggle">
          <button
            className={cn("view-btn", viewMode === "grid" && "active")}
            onClick={() => setViewMode("grid")}
            style={viewMode === "grid" ? { backgroundColor: themeColor } : {}}
          >
            <Grid3x3 size={18} />
          </button>
          <button
            className={cn("view-btn", viewMode === "list" && "active")}
            onClick={() => setViewMode("list")}
            style={viewMode === "list" ? { backgroundColor: themeColor } : {}}
          >
            <List size={18} />
          </button>
        </div>
      </div>

      {/* Agents Grid/List */}
      <div className="agent-selector-content">
        {filteredAgents.length === 0 ? (
          <div className="empty-state">
            <p>No agents found matching "{searchQuery}"</p>
            <Button 
              color="link" 
              onClick={() => setSearchQuery('')}
              style={{ color: themeColor }}
            >
              Clear search
            </Button>
          </div>
        ) : (
          <div className={cn(
            "agents-container",
            viewMode === "grid" ? "grid-view" : "list-view"
          )}>
            {filteredAgents.map(agent => (
              <div 
                key={agent.id} 
                className={cn(
                  "agent-wrapper",
                  selectedAgent?.id === agent.id && "selected"
                )}
              >
                <AgentCard
                  agent={agent}
                  onSelect={onSelectAgent}
                  compact={viewMode === 'list'}
                  themeColor={themeColor}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AgentSelector;